import { _internal_initSideEffectEmitterSingleton } from '@wix/agent-platform-bm-sdk';
import { useSideEffectListener } from '../useStreaming/useSideEffectListener';
export function useChatServiceDuplexerConnector(connection) {
  const internalEmitter = _internal_initSideEffectEmitterSingleton();
  useSideEffectListener({
    connection,
    onSideEffect: (_payload, sideEffect) => {
      internalEmitter.emitEvent(sideEffect);
    }
  });
}
//# sourceMappingURL=useChatServiceDuplexer.js.map